export default {
    SIZE: {
        itemWidth: 10,
        itemHeight: 10,
        itemGap: 16,
        nameGap: 100,
        boundaryGap: ['20%', '20%'],
        fontSize: 14,
        legend: {
            left: 'auto',
            right: 10,
            top: 0,
            bottom: 0,
            itemWidth: 10,
            itemHeight: 10,
            itemGap: 16,
            icon: 'stack'
        },
        grid: {
            top: 50,
            left: 0,
            right: 20,
            bottom: 10,
            containLabel: true
        },
        mGrid: {
            top: 50,
            width: 'auto',
            bottom: '45%',
            left: 30,
            right: 50,
            containLabel: true
        },
        label_font_size: 12,
        bar_width: '12%',
        bar_gap: '30%',
        hbar_width: '40%',
        roseItemGap: 16
    }
}


// WEBPACK FOOTER //
// ./src/model/chartOption.js